import { Button, ButtonProps } from '@chakra-ui/react';

export const CreateOfferScorecardButton = ({
  onClick,
  isLoading,
  ...rest
}: ButtonProps) => {
  return (
    <Button
      isLoading={isLoading}
      size="sm"
      variant="solid"
      width={{ base: '50%', md: 'auto' }}
      onClick={onClick}
      {...rest}
    >
      Create Offer Scorecard
    </Button>
  );
};
